import React from 'react';
import { IBonusToDisplay } from '@core/js/components/main/BonusHistory/types';
import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import { BONUS_STYLES_TRANSLATIONS_MAP } from '@core/js/components/main/BonusHistory/hooks/useTableData/constants';

export type GetRenderBonusNameType = {
    style: Record<string, string>;
    showTermsPopup: (event: React.MouseEvent<HTMLElement>, termAndConditionWebContentId: string, title: string) => void;
    translate: ITranslateMethod;
}

export const getRenderBonusName = ({ style, showTermsPopup, translate }: GetRenderBonusNameType) => (item: IBonusToDisplay) => {
    const bonusName = item.marketingName || item.templateName;
    const bonusStylesTranslationConf = BONUS_STYLES_TRANSLATIONS_MAP.find((element) => element.type === item.status);

    return (
        <>
            <div className={style.highlight}>
                <span
                    className={style.bonusName}
                    onClick={(event) => {
                        if (item.detailedWebContentId) {
                            showTermsPopup(event, item.detailedWebContentId, bonusName);
                        }
                    }}
                >
                    {bonusName}
                </span>
            </div>
            <div className={`${style.status} ${bonusStylesTranslationConf ? style[bonusStylesTranslationConf.style] : ''}`}>
                {translate(bonusStylesTranslationConf?.translation || '')}
            </div>
        </>
    );
};
